import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/layout.js");
